<div class="accordion tw-w-full">
  <button
    class="accordion-header tw-flex tw-w-full tw-items-center tw-justify-between tw-px-4 tw-py-2.5"
    [ngClass]="headerClass"
    type="button"
    (click)="collapse.toggle()"
    [disabled]="isDisabled"
    [attr.aria-expanded]="!isCollapsed"
    aria-controls="collapseExample"
  >
    <ng-content select="[accordion-title]"></ng-content>

    @if (!isDisabled) {
      <p-icon name="chevron-down" class="accordion-icon"></p-icon>
    }
  </button>

  <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
    <div class="accordion-body tw-border-t tw-border-divider">
      <ng-content></ng-content>
    </div>
  </div>
</div>
